import { render, staticRenderFns } from "./VueHighcharts.vue?vue&type=template&id=4cfa5c58&scoped=true&"
import script from "./VueHighcharts.vue?vue&type=script&lang=js&"
export * from "./VueHighcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa5c58",
  null
  
)

export default component.exports